<!--Wird eingebunden-->
<template>
  <div :class="['bookable-action-box', `box-theme-${boxTheme}`, `content-theme-${contentTheme}`]">
    <div class="bookable-info">
      <span class="bookable-prepend" v-if="info.prepend">{{info.prepend}}</span>
      <span class="bookable-name">{{info.name}}</span>
      <span class="bookable-info-text">{{info.info}}</span>
    </div>

    <BookableDetails :details="details">
      <template v-for="slot in possibleChildSlotsFor('Details')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </BookableDetails>

    <div id="bookable-actions" class="bookable-actions">
      <button v-for="action in actions" :class="'btn btn-default type-' + action.type" v-bind:key="action.type" :disabled="action.disabled" @click="$emit(`click:${action.type}`)">
        {{action.text}}
      </button>
    </div>
  </div>
</template>

<script>/**
 * Generische Anzeigekomponente für buchbare Elemente (Tarife, Tarifoptionen, Service-Optionen)
 */

import slotProxy from '@/mixins/slotProxy'
import BookableDetails from './Details.vue'

export default {
  name: 'BookableDetailsWithActions',
  components: { BookableDetails },
  mixins: [
    slotProxy()
  ],
  props: {
    /**
     * provide string with a custom theme name. is used as class box-theme-$boxTheme on the root element
     * usual options: light or dark
     */
    boxTheme: {
      type: String,
      default: 'dark'
    },
    /**
     * provide string with a custom theme name. is used as class content-theme-$contentTheme on the root element
     */
    contentTheme: {
      type: String,
      default: 'default'
    },
    /**
     * provide array with objects of following attributes:
     * - type: a unique identifier for this button. Will result in Event click:$type when button is clicked
     * - text: content for the button text
     */
    actions: {
      type: Array,
      default: () => []
    },
    /**
     * provide array with objects of following attributes
     * - primary: the first line of the box, usually displayed in bigger font size
     * - secondary: the seconds line of the box, usually displayed in smaller font size
     */
    details: {
      type: Array,
      default: () => []
    },
    /**
     * main info section, provide an object with following attributes
     * - (optional) prepend: a small line before the headline of the box
     * - name: the name of the bookable to be displayed, usually the tariff or tariffoption name
     * - (optional) info: an additional info text which can be used to describe the progress of a change operation
     */
    info: {
      type: Object,
      default: () => {
        return { name: '', info: '' }
      }
    }
  }
}
</script>
